export default __webpack_public_path__ + "static/media/add-routing-intents2.bd8dcb98.png";